import webcolors from 'webcolors/webcolors'
import templateUrl from 'webcolors/color-input.htm'
import popoverUrl from 'webcolors/color-input-popover.htm'
import resolve from 'ioc/resolve'
import basicController from 'servicestack/basic.controller.properties'


class ColorInputController {
    constructor($state) {
        basicController(this)
        const $ctrl = this;
        $ctrl.webcolors = webcolors;
        $ctrl.popoverUrl = popoverUrl;
    }

    set(color){
        this.color = color;
        this.onChange({color});
    }

    isDark(){
        return webcolors.isDark(this.color);
    }
}

let ColorInputComponent = {
    bindings: {
        color: '=ngModel',
        onChange: '&',
        classes: '@',
        popoverPlacement: '@'
    },
    controller: ColorInputController,
    templateUrl($element, $attrs) {
        return $attrs.templateUrl || templateUrl;
    }
}

export default ColorInputComponent;